import classnames from 'classnames/bind';
import React from 'react';
import styles from 'presentation/components/styles/__demo__/SuggestedAnswers.css';
import AnswerItemContainer from 'presentation/containers/__demo__/AnswerItemContainer';
import PropTypes from 'prop-types';

let cx = classnames.bind(styles);

class SuggestedAnswers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    const suggestedAnswersPropTypes = {
      suggestedAnswers: PropTypes.array,
    };
    PropTypes.checkPropTypes(suggestedAnswersPropTypes, props, 'prop', 'Search');
  }

  render() {
    return (
      <div>
        <div className={cx(styles.suggested_answer_title)}>COMMON QUESTIONS</div>
        <div className={cx(styles.suggested_answers_container)}>
          <div>
            {this.props.suggestedAnswers.map(answer => (
              <AnswerItemContainer
                answerId={answer.id}
                isSearchedAnswer={false}
                key={answer.id}
                name={answer.name.toString()}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default SuggestedAnswers;
